$(document).ready(function() {

  var path = location.pathname.substring(1);
  if (path) {
    $('.nav_parh li a[href$="' + path + '"]').parents('li').addClass('selected');    
    $('.nav_parh ul ul a[href$="' + path + '"]').parents('li').addClass('selected');
  }
  $(document).on('click','#RecoverPassword',function(){
    $(this).parents('.theme-collection').find("#RecoverPasswordForm").toggleClass('hide');
    $(this).parents('.theme-collection').find("#CustomerLoginForm").toggleClass('hide');
  });
  $(document).on('click','#HideRecoverPasswordLink',function(){
    $(this).parents('.theme-collection').find("#RecoverPasswordForm").toggleClass('hide');
    $(this).parents('.theme-collection').find("#CustomerLoginForm").toggleClass('hide');
  });
});

// Because of the way this file is set up, this works the same
// as a document.ready statement.
// Add your code, either within the misc: section, or create your own function
// if you create your own, make sure to add a line at the bottom to run that code
// ie: Engine.ui.misc();
$(function() {
  "use strict";
  var Engine = {
    ui: {
      stickyHeader: function() {
        $(window).scroll(function() {
          if ($(this).scrollTop() >= 1) {
            $('.primary_nav').addClass('stickyHeader');
            $('.detail_breadcrumb').addClass('stickymove');
          } else {
            $('.primary_nav').removeClass('stickyHeader');
            $('.detail_breadcrumb').removeClass('stickymove');
          }
        });

      },
      BGfillBox: function () {
        $('.fill-box').fillBox();
      }, // end BG fill Box


      misc: function() {
        $(".btn-search,.btn-close-search").on('click', function () {
          $(".topheader").toggleClass("opensearch");
          return false;
        });

        $(".navbar-expand-toggle,.close-nav").on('click', function() {
          $(".app-container").toggleClass("expanded");
          return false;
        });
        //  Sidebar Menu

        var SideContentHeight = $('.app-sidemenu .asm-header').innerHeight() + + $('.app-sidemenu .asm-footer').innerHeight() + 1;
        $('.app-sidemenu .asm-middle').css('height',$( window ).height() - SideContentHeight + 'px');



        $("#shoppingcart,.cart-close").on('click', function () {
          $("body").toggleClass("CartOpen");
          return false;
        });
        /*---------   Quantity Counter   ---------*/

        $('.plus').on('click', function () {
          var $qty = $(this).parents('.CartItem').find("ul.cart_a_quantity li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal)) {
            $qty.val(currentVal + 1);
          }
        });
        $('.minus').on('click', function () {
          var $qty = $(this).parents('.CartItem').find("ul.cart_a_quantity li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal) && currentVal > 1) {
            $qty.val(currentVal - 1);
          }
        });

        $('.plus').on('click', function () {
          var $qty = $(this).parents('.CartItem').find("ul.cart_p_quantity li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal)) {
            $qty.val(currentVal + 1);
          }
        });
        $('.minus').on('click', function () {
          var $qty = $(this).parents('.CartItem').find("ul.cart_p_quantity li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal) && currentVal > 0) {
            $qty.val(currentVal - 1);
          }
        });  
        /*---------   Home Product tab   ---------*/
        $('.hpt-item ul.nav li a').on('click', function(event) {

          event.preventDefault();
          $('.col-5-slider').slick('unslick');                    
          var tab = $(this).attr("href");
          $(tab).fadeIn();
          $(".tab-pane").not(tab).css("display", "none");
          $('.col-5-slider').slick({arrows: true, infinite: true, speed: 1000, slide: 'li', slidesToShow: 5, slidesToScroll: 1, adaptiveHeight: true, autoplay: false, dots: false, 
                                    responsive: [{breakpoint: 1364, settings: {slidesToShow: 4, slidesToScroll: 1, infinite: true, }},{breakpoint: 1023, settings: {slidesToShow: 3, slidesToScroll: 1, infinite: true, }},,{breakpoint: 767, settings: {slidesToShow: 2, slidesToScroll: 1, infinite: true, }},{breakpoint: 568, settings: {slidesToShow: 1, slidesToScroll: 1, infinite: true, }},]
                                   });

        });

        var currency_list = $('header .topheader .lang-nav ul').html();
        $('.app-sidemenu ul.metismenu>li.currency').append('<ul>'+ currency_list +'</ul>');


        /*---------   shop Match Height   ---------*/
        $('.shop_item .shop_desc h6,.services-block,.collection-list .collection-desc h6').matchHeight({
          property: 'min-height'
        });
        $('.shop_item .shop_desc, .collection-list .collection-desc').matchHeight({
          property: 'min-height'
        });


        $('.slide-caption ul.dropdown-menu li a').click(function(e) {
          var dropdown_text = $(this).text();
          var dropdown_herf = $(this).attr('href');
          $('.dropdown #press_model>span.text').text(dropdown_text);
          $('.slide-caption #btn_shop_now').attr("href",dropdown_herf);
          $('.dropdown').removeClass('open');
          //return false;
        });




        // Show reset password form

        $(document).on('click','#RecoverPassword',function(evt){
          evt.preventDefault();
          $('#RecoverPasswordForm').toggleClass('hide');
          $('#CustomerLoginForm').toggleClass('hide');
        });

        // Hide reset password form
        $(document).on('click','#HideRecoverPasswordLink',function(evt){
          evt.preventDefault();
          $('#RecoverPasswordForm').toggleClass('hide');
          $('#CustomerLoginForm').toggleClass('hide');
        });


        var $newAddressForm = $('#AddressNewForm');

        if (!$newAddressForm.length) {
          return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(
            'AddressCountryNew',
            'AddressProvinceNew',
            {
              hideElement: 'AddressProvinceContainerNew'
            }
          );
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function() {
          var formId = $(this).data('form-id');
          var countrySelector = 'AddressCountry_' + formId;
          var provinceSelector = 'AddressProvince_' + formId;
          var containerSelector = 'AddressProvinceContainer_' + formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
          });

        });       


        $('.address-new-toggle').on('click', function(e) {
          $('#AddressNewForm').toggleClass('hide');
        });

        $('.address-edit-toggle').on('click', function() {
          var formId = $(this).data('form-id');
          $('#EditAddress_' + formId).toggleClass('hide');
        });

        $('.address-delete').on('click', function() {
          var $el = $(this);
          var formId = $el.data('form-id');
          var confirmMessage = $el.data('confirm-message');

          // eslint-disable-next-line no-alert
          if (
            confirm(
              confirmMessage || 'Are you sure you wish to delete this address?'
            )
          ) {
            Shopify.postLink('/account/addresses/' + formId, {
              parameters: { _method: 'delete' }
            });
          }
        });






      }, // end misc
      metisNavMenu: function() {
        $("#side-menu").metisMenu();
      }, // end metisMenu

    }, // end ui
    utils: {
      sliders: function() {
        //  Home Slider
        /*$('.Homeslider').slick({
                    arrows: false,
                    speed: 1000,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    touchMove: true,
                    slide: 'li'
                });*/


        $('.shop_slider').slick({

          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          slide:'li',
          infinite: false,
          asNavFor: '.shop_thumb'	
        });		

        $('.shop_thumb').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.shop_slider',
          dots: false,
          centerMode: false,
          infinite: false,
          focusOnSelect: true

        }); 
        //  5 columns Slider
        $('.col-2-slider').slick({
          arrows: true, 
          infinite: false, 
          speed: 1000, 
          slide: 'li', 
          slidesToShow: 2, 
          slidesToScroll: 1, 
          adaptiveHeight: true, 
          autoplay: false, 
          dots: false, 
          responsive: [
            {breakpoint: 767, settings: {slidesToShow: 1, slidesToScroll: 1, infinite: true, }},]
        })

        //  5 columns Slider
        $('.col-5-slider').slick({arrows: true, infinite: true, speed: 1000, slide: 'li', slidesToShow: 5, slidesToScroll: 1, adaptiveHeight: true, autoplay: false, dots: false, 
                                  responsive: [{breakpoint: 1364, settings: {slidesToShow: 4, slidesToScroll: 1, infinite: true, }},{breakpoint: 1023, settings: {slidesToShow: 3, slidesToScroll: 1, infinite: true, }},,{breakpoint: 767, settings: {slidesToShow: 2, slidesToScroll: 1, infinite: true, }},{breakpoint: 568, settings: {slidesToShow: 1, slidesToScroll: 1, infinite: true, }},]
                                 });
        //  4 columns Slider
        $('.col-4-slider').slick({arrows: true, infinite: true, speed: 1000, slide: 'li', slidesToShow: 4, slidesToScroll: 1, adaptiveHeight: true, autoplay: false, dots: false,
                                  responsive: [{breakpoint: 801, settings: {slidesToShow: 3, slidesToScroll: 1, infinite: true, }}, {breakpoint: 568, settings: {slidesToShow: 2, slidesToScroll: 1, infinite: true, }}, 
                                               {breakpoint: 412, settings: {slidesToShow: 1, slidesToScroll: 1, infinite: true, }},]
                                               });	


                                               },
                                               }, // end utils
                                               };



                                               Engine.ui.misc();
                                               Engine.ui.metisNavMenu();
                                               //Engine.ui.stickyHeader();
                                               Engine.ui.BGfillBox();	
                                               Engine.utils.sliders();


                                               });

                                               /*$("ul.megabox_nav>li.mb-item>a").hover(function(){
	$('ul.megabox_nav>li.mb-item').removeClass('active');
	if($(this).find('ul').is(':visible')){
		$(this).parent('li').removeClass('active');
	}else{
		$(this).parent('li').addClass('active');
	}
});*/



                                               $(document).on('click', function(e) {
                                               var popup = $(".app-sidemenu");
                                               if (!$('.navbar-expand-toggle').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
                                               if ($(".app-container").hasClass("expanded")) {
                                               $(".close-nav").trigger("click");
                                               }
                                               }
                                               });
                                               $(document).on('click', function(e) {
                                               var popup = $(".cart-side-panel");
                                               if(!$('#cart.shopping-cart').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0){
                                               if ($("body").hasClass("CartOpen")){
                                               $(".cart-close").trigger("click");
                                               }
                                               }
                                               });



                                               $(document).ready(function(e) {
                                               var $filterSidebar = $('#shop-widgets-filters');

                                               var $toggleButton = $('#open_filters');
                                               var $overlay = $('body').find('.widgets-filter-overlay');
                                               function _open() {
                                               $filterSidebar.addClass('open');

                                               if (! $overlay.length) {
                                               $('body').append('<div class="widgets-filter-overlay"></div>');
                                               }

                                               $('body').addClass('open-filters-open');
                                               }

                                               function _close() {
                                               $filterSidebar.removeClass('open');
                                               $(document).find('.widgets-filter-overlay').remove();
                                               $('body').removeClass('open-filters-open');
                                               }

                                               $toggleButton.on('click', function() {
                                               if (! $filterSidebar.hasClass('open')) {
                                               _open();
                                               } else {
                                               _close();
                                               }
                                               });

                                               $('body').on('click', '.widgets-filter-overlay', function() {
                                               _close();
                                               });
                                               $('.filters_close').on('click', function(e) { 
                                               $('.shop-widgets-filters').removeClass('open');  
                                               $(document).find('.widgets-filter-overlay').remove();
                                               $('body').removeClass('open-filters-open');               

                                               });                      
                                               });

                                               $(document).ready(function(e) {
                                               wow = new WOW(
                                               {
                                               animateClass: 'animated',
                                               offset:       100,
                                               iteration: 1,
                                               callback:     function(box) {}
                                               }
                                               );
                                               wow.init();
                                               });                              
                                               
                                               $(document).ready(function(e) {
                                               var submenu = document.querySelector('.select-press-model ul').innerHTML;
                                               $('ul[aria-labelledby="press_model"]').html(submenu);
                                               });                              



